export default "__VITE_PUBLIC_ASSET__6c7fb388__"